/**
 * Where a build indicator should take you.
 *
 * Every running build used to lead to `/build/<jobId>`, which is right for the
 * thing that screen was built for: one deck being written, with its own
 * filmstrip, and the editor waiting at the end.
 *
 * It is wrong for a case-study import. That build's target is the shared
 * library bank, so the watch screen shows the WHOLE bank — every item's slides
 * in one strip, renumbered into a single running order that belongs to nothing
 * — and finishes by opening `/editor/rkh-library`, which is that same
 * amalgamation in the deck editor. Neither is a thing anyone asked to see. The
 * item is on the shelf, so the shelf is where the build leads — and the shelf
 * is the Slides tab specifically, which has needed saying since the Bank took
 * over /library as the Library's default view.
 *
 * One home for the rule because two indicators render it (the header's
 * BuildsIndicator and the dashboard's BuildsInProgress strip), and a rule
 * copied into both is a rule that will only be fixed in one.
 */

/** The slide-bank deck behind /library. Mirrors BANK_SLUG in routes/Library.tsx
 *  and BANKS in server/pipeline/banks.ts. */
export const LIBRARY_BANK_SLUG = 'rkh-library';

/** True for a build whose result is a library item rather than a deck. */
export function isLibraryBuild(slug: string | undefined | null): boolean {
  return slug === LIBRARY_BANK_SLUG;
}

/** The route to open for a build row, running or finished. */
export function buildDestination(build: { id: string; slug?: string | null }): string {
  return isLibraryBuild(build.slug) ? '/library/slides' : `/build/${build.id}`;
}
